import { Injectable } from "@angular/core";
import { getFeatureFlagFromRouteData } from "./feature-flag";
import { FeaturesConfig } from "../../../environments/appEnvironmentConfig";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagService {
  public isEnabled(featureFlag: keyof FeaturesConfig): boolean {
    return environment.features[featureFlag] === true;
  }

  public isEnabledForRouteData(data: unknown): boolean {
    const featureFlag = getFeatureFlagFromRouteData(data);

    return featureFlag !== null && this.isEnabled(featureFlag);
  }
}
